import React from "react";
import { Field } from "./../../../lib/FieldForm";


const RenderItem = props => {
    const {
        field: { control, meta, form },
        fieldName,
        requiredClear,
        label,
        extra,
        children,
        renderMeta,
        mapMetaToChildren
    } = props;

    const childNode =
        typeof children === "function"
            ? children(control, meta, form)
            : React.cloneElement(children, Object.assign({
                ...control,
                ...(mapMetaToChildren ? mapMetaToChildren(meta) : {})
            }, children.props && children.props.onChange ? {
                // 组合子组件 onChange event
                onChange: (v) => {
                    control.onChange(v);
                    children.props.onChange(v);
                }
            } : null));
    
    const errorsText = meta && Array.isArray(meta.errors) && meta.errors.filter((v) => (typeof v === "string" && !!v.trim()));
    
    return props.itemDOM(
        meta,
        label,
        extra,
        fieldName,
        childNode,
        errorsText,
        renderMeta,
        requiredClear
    ) || null;
};

/**
 * Form表单用来自定义错误消息提示
 * @param {string} fieldName                        input.id & input.name & label.for
 * @param {string} label                            FormItem Label字段
 * @param {array} rules                             FormItem 验证规则
 * @param {boolean} requiredClear                   是否要清除label标签的 * 号
 * @param {ReactNode} extra                         FormItem 备注信息
 */
export default props => {
    const {
        label,
        children,
        fieldName,
        renderMeta,
        requiredClear,
        mapMetaToChildren,
        ...restProps
    } = props;

    return <Field name={fieldName} {...restProps}>
        {(control, meta, form) => {
            return <RenderItem field={{ control, meta, form }} {...props} />;
        }}
    </Field>
};
